import {
  retrieveReportsMatterActivity,
  type RetrieveReportsMatterActivityInput,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsMatterActivityQueryOptions = (
  filters: RetrieveReportsMatterActivityInput,
) => {
  return {
    queryKey: [queryKeys.reports, "matter-activity", filters],
    queryFn: () => retrieveReportsMatterActivity(filters),
  };
};
